export const getGiftItemsFromCart = (items, giftSku, parentId) => {
    return items.filter((item) => item.isGift === true && item.sku === giftSku && item.parentGiftId === parentId);
};
//# sourceMappingURL=getGiftItemsFromCart.js.map